import React from 'react'
import './discoverycard.css'
import { Link } from 'gatsby'
import { ArrowRight } from '../../icons'

interface IDiscoryCardProps {
  title: string
  link: string
}

const DiscoveryCard = (props: IDiscoryCardProps) => {
  const { title, link } = props
  return (
    <div className="dc-container">
      <a href={link}>
        <div className="dc-wrapper">
          <svg
            width="49"
            height="48"
            viewBox="0 0 49 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 29.3333C0 27.8606 1.19391 26.6667 2.66667 26.6667H18.6667C20.1394 26.6667 21.3333 27.8606 21.3333 29.3333V45.3333C21.3333 46.8061 20.1394 48 18.6667 48H2.66667C1.19391 48 0 46.8061 0 45.3333V29.3333Z"
              fill="#001C64"
            />
            <path
              d="M13.3305 16C13.3305 14.5272 14.5244 13.3333 15.9972 13.3333H31.9999C33.4727 13.3333 34.6666 14.5272 34.6666 16V31.9997C34.6666 33.4724 33.4727 34.6663 31.9999 34.6663H15.9972C14.5244 34.6663 13.3305 33.4724 13.3305 31.9997V16Z"
              fill="#5BBBFC"
            />
            <path
              d="M26.6667 2.66667C26.6667 1.19391 27.8606 0 29.3333 0H45.3345C46.8072 0 48.0011 1.19391 48.0011 2.66667V18.6665C48.0011 20.1393 46.8072 21.3332 45.3345 21.3332H29.3333C27.8606 21.3332 26.6667 20.1393 26.6667 18.6665V2.66667Z"
              fill="#6FC400"
            />
            <path
              d="M45.3334 3.33325C45.3334 2.96506 45.0349 2.66659 44.6667 2.66659L38.1667 2.66659C37.7985 2.66659 37.5001 2.96506 37.5001 3.33325V4.33325C37.5001 4.70144 37.7985 4.99992 38.1667 4.99992H41.3501L37.1464 9.20356C36.8861 9.46391 36.8861 9.88602 37.1464 10.1464L37.8535 10.8535C38.1139 11.1138 38.536 11.1138 38.7963 10.8535L43.0001 6.64975V9.83325C43.0001 10.2014 43.2985 10.4999 43.6667 10.4999H44.6667C45.0349 10.4999 45.3334 10.2014 45.3334 9.83325V3.33325Z"
              fill="#005400"
            />
            <path
              d="M34.6668 21.3332H29.3333C27.8606 21.3332 26.6667 20.1393 26.6667 18.6665V13.3333H31.9999C33.4727 13.3333 34.6666 14.5272 34.6666 16L34.6668 21.3332Z"
              fill="#FAF8F5"
            />
            <path
              d="M21.3333 34.6663H15.9972C14.5244 34.6663 13.3305 33.4724 13.3305 31.9997L13.3307 26.6667H18.6667C20.1394 26.6667 21.3333 27.8606 21.3333 29.3333V34.6663Z"
              fill="#FAF8F5"
            />
          </svg>
          <div className="dc-title boldText">{title}</div>
          <ArrowRight />
        </div>
      </a>
    </div>
  )
}

export default DiscoveryCard
